export default __webpack_public_path__ + "static/media/08_meow.80bcb6ca.webp";